var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',{staticClass:"text-neutral-600"},[_vm._v("Api de conversões")]),_c('div',{staticClass:"row"},_vm._l((_vm.options),function(option){return _c('div',{key:option.title,staticClass:"col-xl-3 col-lg-4"},[_c('button',{on:{"click":function($event){return _vm.$router.push({
            name: option.route,
            params: { id: _vm.$route.params.id }
          })}}},[_c('feature-card',_vm._b({attrs:{"color":"#0693FF"}},'feature-card',option,false))],1)])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }